import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuArrowRight, LuSparkles } from 'react-icons/lu';

/**
 * The Ask Me box in the top bar, on every page except Ask Me itself.
 * A question typed here opens the Ask Me page, which starts a new conversation with it
 * (AskMePage reads `location.state.question`).
 */
const AskMeBar = ({ schoolId }) => {
  const [question, setQuestion] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedQuestion = question.trim();
    if (!trimmedQuestion) {
      return;
    }

    setQuestion('');
    navigate(`/dash/${schoolId}/ask`, { state: { question: trimmedQuestion } });
  };

  return (
    <form role="search" onSubmit={handleSubmit} className="relative w-full">
      <LuSparkles aria-hidden className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-brand-500" />
      <input
        type="text"
        value={question}
        onChange={(event) => setQuestion(event.target.value)}
        aria-label="Ask Me a question"
        placeholder="Ask Me anything about your school's academic performance…"
        className="h-9 w-full rounded-lg border border-ui-line bg-ui-muted pr-11 pl-9 text-sm text-ui-ink outline-none transition-[border-color,box-shadow,background-color] placeholder:text-ui-ink-3 hover:border-ui-input focus:border-brand-500 focus:bg-ui-card focus:ring-4 focus:ring-brand-500/20"
      />
      <button
        type="submit"
        aria-label="Ask"
        title="Ask"
        disabled={!question.trim()}
        className="absolute top-1/2 right-1 flex size-7 -translate-y-1/2 items-center justify-center rounded-md bg-brand-600 text-white transition-colors hover:bg-brand-700 disabled:bg-transparent disabled:text-ui-ink-3"
      >
        <LuArrowRight aria-hidden className="size-4" />
      </button>
    </form>
  );
};

export default AskMeBar;
